import { c as _c } from "react/compiler-runtime";
// Иконка «Чаты» в шапке (макет: пузырь с тремя точками между корзиной и
// профилем, вектор `Outline/Chat`; на /chats — акцент #FA5C2E). Активное
// состояние — залитый пузырь с белыми точками (Айталы A-04; в макете залитого
// рисунка нет, он собран из того же вектора — ChatFilledIcon). Только для
// вошедшего покупателя; бейдж — сумма непрочитанных по всем тредам. Кнопка
// 40×40, иконка 24×24 — как у соседних IconLink шапки.
import { NavLink } from "react-router";
import { ChatIcon } from "@/components/icons";
import { cn } from "@/lib/utils";
import { useProfile } from "@/store/profile";
import { useChatUnreadTotal } from "../../api/use-chats";
import { ChatFilledIcon } from "./chat-filled-icon";
export function HeaderChatLink(t0) {
  const $ = _c(2);
  const {
    onDark: t1
  } = t0;
  const onDark = t1 === undefined ? false : t1;
  const user = useProfile(_temp);
  if (!user) {
    return null;
  }
  let t2;
  if ($[0] !== onDark) {
    t2 = <ChatLink onDark={onDark} />;
    $[0] = onDark;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
function _temp(s) {
  return s.user;
}
function ChatLink(t0) {
  const $ = _c(8);
  const {
    onDark
  } = t0;
  const count = useChatUnreadTotal();
  const t1 = count > 0 ? `Чаты (${count})` : "\u0427\u0430\u0442\u044B";
  let t2;
  if ($[0] !== onDark) {
    t2 = t3 => {
      const {
        isActive
      } = t3;
      return cn("relative flex size-10 items-center justify-center rounded-full transition-colors", isActive ? "text-[#FA5C2E]" : onDark ? "text-white hover:bg-white/15" : "text-osmix-text-1 hover:bg-osmix-gray-100");
    };
    $[0] = onDark;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count) {
    t3 = t4 => {
      const {
        isActive: isActive_0
      } = t4;
      return <>{isActive_0 ? <ChatFilledIcon size={24} /> : <ChatIcon size={24} />}{count > 0 && <span className="absolute -top-0.5 -right-0.5 flex min-w-[18px] items-center justify-center rounded-full bg-osmix-tangelo px-1 text-[11px] leading-[18px] font-bold text-white">{count > 99 ? "99+" : count}</span>}</>;
    };
    $[2] = count;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <NavLink to="/chats" aria-label={t1} className={t2}>{t3}</NavLink>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}